import { ArticleParagraph1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './Underground.css';
import { UndergroundIcon } from '../UndergroundIcon';

export interface IUndergroundProps {
  regionId: number;
  name?: string;
  lineColor?: string | null;
  time: string;
  searchUrl: string | undefined;
  underConstruction: boolean | undefined;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Underground: React.FC<IUndergroundProps> = ({
  regionId,
  time,
  name,
  lineColor,
  searchUrl,
  underConstruction,
  onClick,
}) => {
  return (
    <div className={styles['container']}>
      {lineColor && <UndergroundIcon className={styles['icon']} color={`#${lineColor}`} regionId={[regionId]} />}
      <span className={styles['name']}>
        {searchUrl ? (
          <a href={searchUrl} className={styles['link']} target="_blank" rel="noopener noreferrer" onClick={onClick}>
            <UIText2 color={underConstruction ? 'text-secondary-default' : 'black_100'}>{name}</UIText2>
          </a>
        ) : (
          <ArticleParagraph1 color={underConstruction ? 'text-secondary-default' : 'black_100'}>
            {name}
          </ArticleParagraph1>
        )}
      </span>
      {time && <UIText2>{`・`}</UIText2>}
      {time && <UIText2 color="text-secondary-default">{time}</UIText2>}
    </div>
  );
};
